<div class="container-fluid">
    <div class="row">
      <div class="col login_col_left">
        <router-outlet></router-outlet>
      </div>
      <div class="col login_col_right">
      </div>
    </div>
</div>
